import React, { Component, Fragment } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Upload, Icon, message, Select, Button } from 'antd'

import { files, users } from '@services/api'

@inject((store: any) => {
    const { popupStore, authStore } = store

    return {
        popupStore,
        authStore
    }
})
@observer
export default class UploadCommissionsPopup extends Component<any, any> {
    state: any = {
        userInfo: {},
        status: 'waiting',
        clear: true,
        selectedYear: new Date().getFullYear(),
        selectedMonth: undefined,
        errors: {}
    }

    closeDone = () => {
        files.commissions().then(() => this.closePopup())
    }

    closePopup = () => {
        this.props.popupStore.togglePopup(false)
        this.resetUpload()
    }

    resetUpload = () => {
        this.setState({ selectedYearh: undefined, selectedMonth: undefined, status: 'waiting', clear: true })
    }

    setError = (errorName, errorMsg) => {
        this.props.popupStore.addErrors(errorName, errorMsg)
        return false
    }

    validateFile = () => {
        return true
    }

    saveUser = async () => {
        if (this.validateFile()) {
        }
    }

    handleSelectedYear = year => {
        this.setState({ selectedYear: year })
    }

    handleSelectedMonth = month => {
        this.setState({ selectedMonth: month })
    }

    toLiteralMonth(number) {
        const months = {
            1: 'ינואר',
            2: 'פברואר',
            3: 'מרץ',
            4: 'אפריל',
            5: 'מאי',
            6: 'יוני',
            7: 'יולי',
            8: 'אוגוסט',
            9: 'ספטמבר',
            10: 'אוקטובר',
            11: 'נובמבר',
            12: 'דצמבר'
        }

        return months[number]
    }

    createYearRange = () => {
        let years = []
        const currentYear = new Date().getFullYear()
        for (let i = 2021; i <= currentYear; i++) {
            years.push(i)
        }
        return years
    }

    createMonthRange = () => {
        let months = []
        let limit = this.state.selectedYear === new Date().getFullYear() ? new Date().getMonth() : 12
        for (let i = 0; i <= limit; i++) {
            months.push(i)
        }
        return months
    }

    render() {
        const {
            isRegularUse,
            popupStore,
            fileUploaded,
            authStore: { fullName }
        } = this.props
        const { status, selectedYear, selectedMonth } = this.state

        let years = this.createYearRange()
        let months = this.createMonthRange()

        const { Dragger } = Upload

        const props = {
            multiple: false,
            showUploadList: false,
            customRequest: async request => {
                const { bucket } = popupStore.info
                const { selectedMonth, selectedYear } = this.state
                const newFile = await request.file
                const formData = new FormData()
                await formData.append('file', newFile)
                const fileType = newFile.name.slice(newFile.name.length - 4, newFile.name.length)
                const related = parseInt(selectedMonth.toString() + selectedYear.toString())

                try {
                    const fileObj = await files.upload(formData, {
                        bucket,
                        related: related,
                        fileType,
                        uniq: 'true',
                        month: selectedMonth,
                        year: selectedYear,
                        commission: true
                    })
                    const file_id = fileObj.data.id

                    isRegularUse && (await users.updateUploadedFileId({ id: related, file_id, updated_by: fullName }))
                    request.onSuccess(res => res)
                    fileUploaded && fileUploaded()
                } catch (e) {
                    request.onError(e => e)
                }
            },
            onChange: info => {
                const { status } = info.file

                this.setState({ status })
                if (status === 'done') {
                    message.success(`הקובץ הועלה בהצלחה`)
                } else if (status === 'error') {
                    message.error(`אירעה שגיאה בהעלאת הקובץ`)
                }
            }
        }

        const uploadMsgMap = {
            waiting: { text: ' גרור לכאן קובץ להעלאה <br/> או לחץ לבחירת קובץ מתוך תיקיה', icon: 'cloud-upload' },
            uploading: { text: 'אנא המתן! <br/> הקובץ בטעינה...', icon: 'loading' },
            done: { text: ' העלאת הקובץ הצליחה! <br/> סגור חלון או העלה קובץ נוסף', icon: 'check-circle' },
            error: {
                text: `העלאת הקובץ נכשלה <br/> וודא כי הקובץ אינו עולה על 5MB וכי סוג הקובץ הוא xlsx`,
                icon: 'warning'
            }
        }

        const uploadMsg = (
            <Fragment>
                <p className="ant-upload-drag-icon">
                    <Icon type={uploadMsgMap[status].icon} />
                </p>
                <p className="ant-upload-text" dangerouslySetInnerHTML={{ __html: uploadMsgMap[status].text }} />
            </Fragment>
        )

        const footerButtons = (
            <Fragment>
                <Button onClick={() => (status === 'done' ? this.closeDone() : this.closePopup())}>
                    {status === 'done' ? 'סגור' : 'ביטול'}
                </Button>
                {status === 'done' || status === 'error' ? (
                    <Button type="primary" onClick={() => this.resetUpload()}>
                        {status === 'done' ? 'העלה קובץ נוסף' : 'נסה שנית'}
                    </Button>
                ) : (
                    ''
                )}
            </Fragment>
        )
        return (
            <Modal
                title="העלאת קובץ"
                visible={popupStore.popupType === 'uploadFile'}
                onCancel={this.closePopup}
                footer={footerButtons}
            >
                {status === 'waiting' ? (
                    <Select
                        style={{ width: '100%' }}
                        placeholder="בחר שנה"
                        value={selectedYear}
                        onChange={year => this.handleSelectedYear(year)}
                        //defaultActiveFirstOption={true}
                        //defaultValue={new Date().getFullYear()}
                        //value={"ddsdsdsdsdsdds"}
                    >
                        {years.map(year => (
                            <Select.Option key={year} value={year}>
                                {year}
                            </Select.Option>
                        ))}
                    </Select>
                ) : (
                    ''
                )}

                {selectedYear && status !== 'error' && status !== 'done' ? (
                    <Select
                        style={{ width: '100%' }}
                        placeholder="בחר חודש"
                        value={selectedMonth}
                        onChange={month => this.handleSelectedMonth(month)}
                    >
                        {months.map(month => (
                            <Select.Option key={month.toString()} value={month}>
                                {this.toLiteralMonth(month)}
                            </Select.Option>
                        ))}
                    </Select>
                ) : (
                    ''
                )}

                {selectedYear && selectedMonth ? (
                    <Dragger disabled={status !== 'waiting'} {...props}>
                        {uploadMsg}
                    </Dragger>
                ) : (
                    ''
                )}
            </Modal>
        )
    }
}
